import { FieldConfig } from "../Components/Form/FormComponent/types";
import countryCode from "../assets/countryCode.json";

export const QUALIFICATION_OPTIONS = [
  "Form 4",
  "SPM",
  "UEC",
  "IGCSE or O-level",
  "STPM",
  "Diploma",
  "Foundation",
  "Others",
];

export const RESULTS_SPM = [
  "Results not out yet",
  "0-2 As",
  "3-5 As",
  "6-8 As",
  "9 As and above",
  "I am not sure",
  "Other",
];

export const RESULTS_UEC = [
  "Results not out yet",
  "Mostly A/B",
  "Mostly B/C",
  "Mostly C/D",
  "I am not sure",
  "Other",
];

export const RESULTS_CGPA = [
  "CGPA 3.50 and above",
  "CGPA 3.00-3.49",
  "CGPA 2.50-2.99",
  "Below CGPA 2.50",
  "I am not sure",
  "Other",
];

export const STUDENT_RESULT_GRADES = [
  "None",
  "1A",
  "2A",
  "3A",
  "4A",
  "5A",
  "6A",
  "7A",
  "8A",
  "9A",
  "10A",
  "11A",
  "12A",
];

export const STUDENT_RESULT_CGPA = [
  "Below CGPA 2.00",
  "CGPA 2.00-2.49",
  "CGPA 2.50-2.99",
  "CGPA 3.00-3.49",
  "CGPA 3.50-4.00",
  "I am not sure",
];

export const getEstimatedResultOptions = (qualification?: string) => {
  if (qualification === "Form 4") {
    return ["Not applicable - I am still in Form 4"];
  }
  if (qualification === "UEC") return RESULTS_UEC;
  if (["Diploma", "Foundation", "STPM"].includes(qualification || "")) {
    return RESULTS_CGPA;
  }
  return RESULTS_SPM;
};

export const getStudentResultOptions = (qualification?: string) => {
  if (["Form 4", "SPM", "UEC"].includes(qualification || "")) {
    return STUDENT_RESULT_GRADES;
  }
  return STUDENT_RESULT_CGPA;
};

export const getLeadFields = (assigneeOptions: string[]): FieldConfig[] => [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "ic", label: "IC", type: "text" },
  { name: "dob", label: "DOB", type: "date" },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: ["Male", "Female", "Other", "Prefer not to say"],
  },
  {
    name: "country",
    label: "Country",
    type: "select",
    options: countryCode.map((c) => c.countryName),
  },
  {
    name: "contact",
    label: "Contact",
    type: "group",
    required: true,
    groupField: [
      {
        key: "countryCode",
        label: "Country Code",
        type: "select",
        options: [],
        disable: true,
      },
      {
        key: "phoneNumber",
        label: "Number",
        type: "text",
      },
    ],
  },
  { name: "email", label: "Email", type: "email" },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      "New",
      "Contacted",
      "Engaging",
      "Potential",
      "Enrolled",
      "Cold",
      "Lost",
      "Unassigned",
      "Duplicate",
    ],
  },
  {
    name: "assignee",
    label: "Assignee",
    type: "select",
    options: ["Unassigned", ...assigneeOptions],
  },
  {
    name: "leadSource",
    label: "Lead Source",
    type: "select",
    options: [
      "Online",
      "School Fair",
      "Website",
      "School Talk",
      "Workshop",
      "Magazine",
    ],
  },
  { name: "campaign", label: "Campaign", type: "text", required: false },
  { name: "createdDate", label: "Created Date", type: "date", disabled: true },
  {
    name: "firstTouchedDate",
    label: "First Touched",
    type: "date",
    disabled: true,
  },
  {
    name: "lastTouchedDate",
    label: "Last Touched",
    type: "date",
    disabled: true,
  },
  { name: "location", label: "Location", type: "text" },
  { name: "preferredUniversity", label: "Preferred University", type: "text" },
  { name: "intake", label: "Intake", type: "text" },
  {
    name: "campusVisit",
    label: "Campus Visit",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    name: "videoCall",
    label: "Video Call",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    name: "familyFinancials",
    label: "Family Financials",
    type: "select",
    options: ["B40", "M40", "T20"],
  },
  {
    name: "qualification",
    label: "Qualification",
    type: "select",
    options: QUALIFICATION_OPTIONS,
  },
  {
    name: "studentResult",
    label: "Student Result",
    type: "select",
    options: getStudentResultOptions(),
  },
  {
    name: "estimatedResult",
    label: "Estimated Result",
    type: "select",
    options: getEstimatedResultOptions(),
  },
  {
    name: "uploadedResult",
    label: "Uploaded Result",
    type: "file",
    accept: ".pdf",
  },
  {
    name: "overseas",
    label: "Overseas",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    name: "interestedCourses",
    label: "Interested Courses",
    type: "text",
    placeholder: "Comma-separated",
  },

  { name: "schoolName", label: "School Name", type: "text" },
  { name: "reason", label: "Reason", type: "text" },
  { name: "remarks", label: "Remarks", type: "text" },
];
